/*
 * [Archies] pdp-morph-image-fix-ext.js
 *
 * Combined-listing colour/swatch morphs re-render the PDP sections via the Section Rendering API.
 * The re-inserted image-block images (e.g. the "What Makes Archies So Comfy?" banner, bound to
 * custom.why_archies_pdp_image) come back with their lazy `data-src` set but NO `src` — the lazy
 * loader that upgrades `data-src` → `src` only runs on the initial page load, not after a morph.
 * Result: those images show the broken-image icon after every swatch change.
 *
 * Fix: on the morph-complete signal (`variantHtmlUpdatedCustomFlag`, the same event tabs / size-gate
 * / thumbnail-sync already hook), promote any image-block image still missing a `src`. This runs ONLY
 * on a user-initiated swatch morph — never on initial load — so lazy-loading (and the Lighthouse
 * gate) is unaffected.
 */
(function () {
  function upgradeImages() {
    document
      .querySelectorAll('img.image-block__image[data-src]:not([src])')
      .forEach(function (img) {
        var ds = img.getAttribute('data-src');
        if (!ds) return;
        var dss = img.getAttribute('data-srcset');
        if (dss && !img.getAttribute('srcset')) img.setAttribute('srcset', dss);
        img.setAttribute('src', ds);
      });
  }

  window.addEventListener('variantHtmlUpdatedCustomFlag', function () {
    // Run after the morphed nodes are in the DOM; rAF catches the common case, the timeout is a
    // safety net for slower morphs. upgradeImages is idempotent (only touches [data-src]:not([src])).
    requestAnimationFrame(upgradeImages);
    setTimeout(upgradeImages, 300);
  });
})();
